import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import { CustomCard } from '../Comman';
import { useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import { ChevronLeft } from 'react-feather';

const SelectBenefitGroup = ({ state, setState, setFormCount }) => {
  const history = useHistory();

  const [selectedBenefitGroup, setSelectedBenefitGroup] = useState(null);
  const [benefitGroupList, setBenefitGroupList] = useState([]);

  const { getBenefitGroup } = useSelector((state: any) => ({
    getBenefitGroup: state.GetBenefitAndBenefitGroup?.data?.results?.benefit_groups,
  }));

  useEffect(() => {
    if (state?.benefitGroup) {
      setSelectedBenefitGroup(state?.benefitGroup);
    }
    if (state?.benefit) {
      setBenefitGroupList(getBenefitGroup[state?.benefit?.name]);
    }
  }, [state]);

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSubmit = () => {
    if (!selectedBenefitGroup) {
      cogoToast.error('Please select project first');
      return;
    }
    setState(prev => ({ ...prev, benefitGroup: selectedBenefitGroup }));
    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Program Onboarding`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Benefit Group List']}
            />
          </div>

          {/* <Filter
            filterHandler={filterSubmitHandler}
            bookingType={bookingType}
            approvalRequestTypeHandler={approvalRequestTypeHandler}
            modification={modification}
          /> */}
        </div>

        <Card>
          <CardHeader>
            <h5 className="m-0 fw-semibold">Select Benefit Group</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <Row className="d-flex mx-1">
              {benefitGroupList?.map((benefitGroup: any, index: number) => {
                const isSelected = selectedBenefitGroup?.id === benefitGroup.id;

                return (
                  <CustomCard
                    clientName={benefitGroup.name}
                    country={''}
                    key={index}
                    selected={isSelected}
                    onClick={() => {
                      if (selectedBenefitGroup?.id === benefitGroup.id) {
                        cogoToast.info('Benefit Group already selected');
                        return;
                      }
                      setState(prev => ({ ...prev, benefitGroup: benefitGroup }));
                      setSelectedBenefitGroup(prev => (prev?.id === benefitGroup.id ? null : benefitGroup));
                      setFormCount((prev: number) => prev + 1);
                    }}
                  />
                );
              })}
            </Row>
          </CardBody>
        </Card>
        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default SelectBenefitGroup;
